export default {
    methods: {
        confirmReplaceMessage () {
            return this.$dialog.confirm({
                title:       this.$t('confirmation-required'),
                text:        this.$t('this-will-replace-message'),
                centerText:  true,
                confirmText: this.$t('replace')
            });
        }
    }
};
